var React = require('react');

function ArrowUpIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 5.361c0 .158.053.328.169.452.232.249.6.249.832 0l4.002-4.287 3.991 4.287c.232.249.6.249.832 0s.232-.645.011-.893L5.423.181A.56.56 0 0 0 5.002 0c-.158 0-.305.068-.421.181L.169 4.92A.64.64 0 0 0 0 5.361h0z","fill":"#269c74","fillRule":"evenodd"}));
}

ArrowUpIconInline.defaultProps = {"width":"10","height":"6","xmlnsV":"https://vecta.io/nano"};

module.exports = ArrowUpIconInline;

ArrowUpIconInline.default = ArrowUpIconInline;
